import React from 'react';
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import styles from "../styles/odds-by-widget.module.scss";
import classNames from "classnames";
import {OddsByWidgetProps} from "../models/odds-by-widget.props";
import {OddsByWidgetController} from "../odds-by-widget.controller";
import {OddsByWidgetContent} from "./odds-by-widget.content";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {APP} from "../../../core/app/consts";

export const OddsByWidget = (({controller, className, shouldRenderWrapper = true}: OddsByWidgetProps) => {
  const {state, device: {isSmallView}} = controller;
  const {cardTitle, shouldRenderWidget} = state;
  const shouldRenderBookmakerLogo: Boolean = !shouldRenderWrapper && !isSmallView;

  const wrapperProps = {
    controller,
    className: classNames(className, styles.container, {[styles.small_view]: isSmallView, [styles.bookmaker_logo_included]: shouldRenderBookmakerLogo}),
    title: cardTitle,
    bookmaker: state.bookmaker,
    source: APP.ANALYTICS.SOURCES.oddsBy,
    shouldRenderWrapper
  }

  return (
    shouldRenderWidget ? <WidgetWrapper {...wrapperProps}>
      <OddsByWidgetContent controller={controller} shouldRenderBookmakerLogo={shouldRenderBookmakerLogo}/>
    </WidgetWrapper> : null
  )
});

const settings: ComposeSettings = {
  component: OddsByWidget,
  propsType: OddsByWidgetProps,
  controllerType: OddsByWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,

  observe: true,
};

export default Compose(settings);
